import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { BsCheck, BsShield } from 'react-icons/bs';
import { MdClose } from 'react-icons/md';
import colors from '../../../assets/styles/colors';
import { ApSecureContext } from '../../../store';
import {
  PlansContainer,
  PlansHeader,
  PlansHeaderIcon,
  PlansHeaderInfo,
  PlansContent,
  PlansTable,
  PlansTableHeader,
  PlansTableCol,
  PlansTableBody,
  PlansTableFooter,
  PlansTableIcon,
  PlansCheckboxContent,
  PlansCheckboxShow,
  PlansCheckboxLabel,
  PlansTableValue
} from './styles';
import { default as ApSecureTypes } from "../../../store/ApSecure/types";
import { getPlans } from '../../../services/plans';
import { formatPrice, writeExtensionOfPrice } from '../../../helpers/price';
import { FormFooter } from '../../../components/FormTemplate/styles';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { apSecureChoseOptions, apSecureSteps } from '../../../helpers/enum';

const PlansPage = ({ setActiveStep }) => {
  const { apSecure, setApSecure } = useContext(ApSecureContext);
  const [plans, setPlans] = useState([])
  const [roofs, setRoofs] = useState([])

  async function initializeStateComponent() {
    try {
      const response = await getPlans();

      setPlans(response.data.planes);
      setRoofs(response.data.coberturas);
    } catch (error) {
      
    }
  }

  function setSelectedPlan(plan) {
    setApSecure({
      type: ApSecureTypes.SET_PLAN,
      plan: plan
    })
  }

  function setNextStep() {
    if(apSecure.option.id === apSecureChoseOptions[0].id) {
      setActiveStep(apSecureSteps.BENEFICIARY);
    } else {
      setActiveStep(apSecureSteps.TAKER);
    }
  }

  useEffect(() => {
    initializeStateComponent();
  }, [])

  return (
    <PlansContainer>
      <PlansHeader>
        <PlansHeaderIcon><BsShield color={colors.textPrimary} size={32} /></PlansHeaderIcon>
        <PlansHeaderInfo>
          Revisa y selecciona el plan que se ajuste a las necesidades del cliente.
        </PlansHeaderInfo>
      </PlansHeader>
      <PlansContent>
        <PlansTable>
          <PlansTableHeader>
            <PlansTableCol width="50%" color={colors.white}>
              Cobertura
            </PlansTableCol>
            {plans.map((item => (
              <PlansTableCol style={{display: 'flex', justifyContent: 'center'}}  key={item.id} width="15%" color={colors.white}>
                {item.nombre}
              </PlansTableCol>
            )))}
          </PlansTableHeader>
          <>
            {roofs.map((item, key) => (
              <PlansTableBody key={key}>
                <PlansTableCol key={key} width="50%" color={colors.textPrimary}>
                  {item.nombre}
                </PlansTableCol>
                {item.detalles.map((detail, i) => (
                  <PlansTableCol key={i} style={{display: 'flex', justifyContent: 'center'}} width="15%" color={colors.white}>
                    {detail.valor === true || detail.valor === false ? (
                      <PlansTableIcon background={detail.valor === true ? colors.bgSuccess : colors.bgDanger }>
                        {detail.valor === true ? <BsCheck color={colors.white} size={12} /> : <MdClose color={colors.white} size={12} />}
                        
                      </PlansTableIcon>
                    ) : <PlansTableValue>{writeExtensionOfPrice(detail.valor)}</PlansTableValue>}
                  </PlansTableCol>
                ))}
              </PlansTableBody>
            ))}
          </>
          <PlansTableFooter>
            <PlansTableCol width="50%" color={colors.white}>
              Prima anual
            </PlansTableCol>
            {plans.map((item, key) => (
              <PlansTableCol key={key} width="15%" color={colors.white}>
                $ {formatPrice(item.monto)}
              </PlansTableCol>
            ))}
          </PlansTableFooter>
        </PlansTable>
        
        {plans.map((item, key) => (
          <PlansCheckboxContent key={key}>
            <PlansCheckboxShow onClick={() => setSelectedPlan(item)} selected={apSecure.plan?.id === item.id} />
            <PlansCheckboxLabel>{item.nombre} - $ {formatPrice(item.monto)}</PlansCheckboxLabel>
          </PlansCheckboxContent>
        ))}

        <FormFooter justify="space-between">
          <DefaultLargeButton type="button" onClick={() => setActiveStep(apSecureSteps.CHOSE_OPTION)} id="back-step">Volver</DefaultLargeButton>
          <SecondaryLargeButton type="button" disabled={!apSecure.plan.id} id="button" onClick={() => setNextStep()}>Siguiente </SecondaryLargeButton>
        </FormFooter>
      </PlansContent>
    </PlansContainer>
  )
}

export default PlansPage;
